module.exports = __webpack_public_path__ + "static/media/traceability.cfe0605d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blog/traceability.jpg
// module id = 489
// module chunks = 0